import React from "react";
import { Search, Home, Calculator } from "lucide-react";

interface AILoadingTextProps {
  className?: string;
  style?: React.CSSProperties;
  type?: "search" | "valuation";
  isHomePage?: boolean;
}

export const AILoadingText: React.FC<AILoadingTextProps> = ({
  className = "",
  style,
  type = "search",
  isHomePage = false,
}) => {
  const content =
    type === "search"
      ? {
          title: "AI is finding your dream home...",
          subtitle:
            "Analyzing thousands of properties to match your perfect home",
        }
      : {
          title: "Calculating your home's value...",
          subtitle:
            "Analyzing market data and comparable properties in your area",
        };

  return (
    <div className={`text-center ${className}`}>
      <div className="flex items-center justify-center mb-2">
        {type === "search" ? (
          <div className="relative">
            <Search
              className="w-6 h-6 xl:w-7 xl:h-7"
              style={{
                color: isHomePage && style?.color ? style.color : "#374151",
              }}
            />
            <Home
              className="w-4 h-4 xl:w-5 xl:h-5 absolute -top-1 -right-3 xl:-right-4 animate-bounce"
              style={{
                color: isHomePage && style?.color ? style.color : "#374151",
              }}
            />
          </div>
        ) : (
          <div className="relative">
            <Calculator
              className="w-6 h-6 xl:w-7 xl:h-7"
              style={{
                color: isHomePage && style?.color ? style.color : "#374151",
              }}
            />
            <span
              className="w-4 h-4 xl:w-5 xl:h-5 absolute -top-1 -right-3 xl:-right-4 animate-bounce"
              style={{
                color: isHomePage && style?.color ? style.color : "#374151",
              }}
            >
              $
            </span>
          </div>
        )}
      </div>
      <h3
        className="text-base lg:!text-lg !font-semibold mb-1 whitespace-nowrap"
        style={style}
      >
        {content.title}
      </h3>
      <p
        className="text-xs lg:text-base"
        style={isHomePage ? { color: `${style?.color}` } : { color: "#6B7280" }}
      >
        {content.subtitle}
      </p>
    </div>
  );
};

export default AILoadingText;
